import React, {useMemo, useState} from "react";
import {Button, Modal, ModalBody, ModalHeader} from "reactstrap";
import NoSearchResult from "../../../../components/Common/NoSearchResult";
import CardExoReplacer from "./CardExoReplacer";
import {useQuery} from "@tanstack/react-query";
import {ExoService} from "../../../../services/exo.service";
import FeatherIcon from "feather-icons-react";
import usePermissions from "../../../../hooks/usePermissions";
import FormCardExoReplacer from "./FormCardExoReplacer";

interface ModalExoReplacerProps {
    isOpen: boolean;
    onClose: () => void;
}

const ModalExoReplacer: React.FC<ModalExoReplacerProps> = ({isOpen, onClose}) => {
    const {hasPermission} = usePermissions();

    const [isCreating, setIsCreating] = useState<boolean>(false)
    const [isAddingReplacement, setIsAddingReplacement] = useState<boolean>(false)
    const [editId, setEditId] = useState<number | null>(null)

    const {data: replacers, isLoading} = useQuery({
        queryKey: ["keyExoReplacers"], queryFn: ExoService.getAllReplacers,
        select: (data) => data.data, refetchOnWindowFocus: false
    });
    const replacerEdit = useMemo(() => replacers?.find(r => r.id === editId), [replacers, editId]);

    const handleCreate = () => {
        setIsCreating(true)
        setIsAddingReplacement(false)
        setEditId(null)
    }

    const handleEdit = (id: number) => {
        setIsCreating(false)
        setIsAddingReplacement(false)
        setEditId(id)
    }

    const handleAddReplacement = (id: number) => {
        setIsCreating(false)
        setIsAddingReplacement(true)
        setEditId(id)
    }

    const handleClose = () => {
        setIsCreating(false)
        setIsAddingReplacement(false)
        setEditId(null)
    }

    const closeModal = () => {
        onClose();
    };

    return (
        <Modal isOpen={isOpen} toggle={closeModal}>
            <ModalHeader toggle={closeModal} tag="h4">
                Replacer
            </ModalHeader>
            <ModalBody>

                {isLoading ? <div className="my-4"><NoSearchResult text="Loading..."/></div> : (
                    <>
                        {hasPermission('create-echo-replacers') && (
                            isCreating ?
                                <FormCardExoReplacer onClose={handleClose}/> : (
                                    <div className="d-flex">
                                        <Button className="d-flex align-items-center gap-2 p-2 mb-3" color="light"
                                                onClick={handleCreate}
                                                disabled={!hasPermission('create-echo-replacers')}>
                                            <FeatherIcon icon="plus-circle" size={22} strokeWidth={1.5}/> Create
                                        </Button>
                                    </div>
                                )
                        )}

                        {replacers?.map((replacer) => {
                            if (editId === replacer.id)
                                return <FormCardExoReplacer key={replacer.id}
                                                            replacer={replacerEdit}
                                                            isAddingReplacement={isAddingReplacement}
                                                            onClose={handleClose}/>

                            return <CardExoReplacer key={replacer.id} replacer={replacer}
                                                    onEdit={handleEdit}
                                                    onAddReplacement={handleAddReplacement}/>
                        })}
                    </>
                )}
            </ModalBody>
        </Modal>
    )
}

export default ModalExoReplacer;